import React from "react";

export default function Header() {
  return (
    <div className="flex w-full justify-evenly items-center">
      <h2 className="font-bold xl:text-7xl text-4xl mt-24 mb-12 text-white">
        GetWeather
      </h2>
    </div>
  );
}
